<template>
<div>
	<header class="header-hamburger">
		<div class="image-logo">
			<a class="navbar-brand" v-html="html_logo" href="/">
			</a>
		</div>
		<div class="hamburger" @click="clickmenu">
			<button class="button hamburger__button js-menu__toggle">
				<span class="hamburger__label"> Open menu </span>
			</button>
		</div>
		<nav class="menu" style="height: 70%;">
			<ul class="list menu__list">
				<li class="menu__group" >
					<a href="#" class="link menu__link" :class="{ 'w3-white': menu == '' }" :href="base_site">
						<div class="icon">
							<i class="glyphicon glyphicon-calendar" />
						</div>
						<span class="title"> Appointment </span>
					</a>
				</li>
				<li class="menu__group">
					<a href="#" class="link menu__link" :class="{ 'w3-white': menu == 'giftcard' }" :href="base_site + 'giftcard'">
						<div class="icon">
							<i class="glyphicon glyphicon-gift" />
						</div>
						<span class="title"> GiftCard </span>
					</a>
				</li>
				<li class="menu__group">
					<a href="#" class="link menu__link" :class="{ 'w3-white': menu == 'aboutus' }" :href="main_site + 'about'">
						<div class="icon">
							<i class="glyphicon glyphicon-phone-alt" />
						</div>
						<span class="title"> About </span>
					</a>
				</li>
				<li class="menu__group">
					<a href="#" class="link menu__link" :class="{ 'w3-white': menu == 'direction' }" :href="main_site + 'contact'">
						<div class="icon">
							<i class="glyphicon glyphicon-map-marker" />
						</div>
						<span class="title"> Directions </span>
					</a>
				</li>
				<li class="menu__group">
					<a :href="base_site + 'login'" class="link menu__link">
						<div class="icon">
							<i class="glyphicon glyphicon-log-in" />
						</div>
						<span class="title"> Login </span>
					</a>
				</li>
			</ul>
		</nav>
	</header>
</div>
</template>

<script>
	import SpaConstants from '../../../constants';
    export default {
        props: {
            
        },
		computed: {
			isLogged() { 
				return this.$store.state.options.islogged;
			},
			site_name(){
				return SpaConstants.site_name;
			},
			html_logo(){
				return SpaConstants.html_logo;
			},
			menu() {
				return this.$store.state.navigation.menu;
			},
			main_site() {
				return window.main_site_url;
			},
			base_site() {
				return window.base_url;
			}
		},
		mounted() {
			if(this.$route.path.indexOf('direction') > 0)
				this.$store.commit('setMenu', 'direction');
			else if(this.$route.path.indexOf('booking') > 0)
				this.$store.commit('setMenu', 'booking');
			else if(this.$route.path.indexOf('giftcard') > 0)
				this.$store.commit('setMenu', 'giftcard');
			else
				this.$store.commit('setMenu', '');
		},
		methods: {
			clickmenu() {
				var _cls = this.$store.state.options.class_mainmenu;
				if(_cls == "" || _cls == undefined) _cls = "js-menu_activated";
				else _cls = "";
				this.$store.commit('setClassMainMenu',  _cls);
			},
		}
    }
</script>

<style>
.image-logo{position: absolute; float: left; left: 20px; top: 8px;}
.image-logo img{height: 40px; border-radius: 4px;}
/*
=====
LEVEL 1. RESET STYLES
=====
*/

button{
  border: none;
  background-color: transparent;
  padding: 0;
  font-family: inherit;
}

.button{
  cursor: pointer;
  color: var(--colorWhite);
}

a{
  display:inline-block;
  text-decoration: none;
}

.link{
  color: inherit;
}

.list{
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  list-style: none;
}

/*
=====
LEVEL 2. MENU STYLES
=====
*/

/* menu */

.header-hamburger{
  box-sizing: border-box;
  width: 100%;
  color: var(--colorWhite);

  display: flex;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  background-color: #ea967c;
  height: 45px;
}

.menu{
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 55px;

  height: 0;
  transform: translate3d(0, -100%, 0);
  opacity: 0;

  display: flex;
  align-items: flex-end;

  position: fixed;
  top: 0;
  left: 0;
}

.menu__list{
  box-sizing: border-box;
  width: 100%;
  max-height: 100%;
  display: none;

  padding-top: 30px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.menu__group{
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
   position: relative;
  float: left;
	width: 48%;
	padding: 5px;
	height: 90px;
}

.menu__group_active{
  background-color: var(--colorWhite);
  color: var(--colorBlack);
}

.menu__item{
  padding: 8px 25px;
  display: block;
}

/* hamburger */

.hamburger{
  position: relative;
  line-height: 1;
  top: -2.5em;
  height:32px;
}

.hamburger:before{
  content :"";
  width: 100px;
  height: 100px;
  background-color: var(--colorMain);
  border-radius: 50%;

  position: absolute;
  bottom: -55px;
  left: -35px;
}

.hamburger__button{
  width: 1.4em;
  height: 1em;
  font-size: 20px;

  position: relative;
  text-indent: -9999px;
  z-index: 2;
  top:50px;
}

.hamburger__button:before, .hamburger__button:after, .hamburger__label{
  width: 100%;
  height: 20%;
  border-radius: 5px;
  background-color: currentColor;

  position: absolute;
  left: 0;
}

.hamburger__button:before, .hamburger__button:after{
  content:"";
}

.hamburger__button:before{
  top: 0;
}

.hamburger__button:after{
  bottom: 0;
}

.hamburger__button:focus{
  outline: none;
}

.hamburger__label{
  margin-top: -.1em;
  top: 50%;
}

/* activated state */

.js-menu_activated{
  overflow: hidden;
}

.js-menu_activated .menu{
  height: 100%;
  transform: translate3d(0, 0, 0);
  opacity: 1;
  padding-left: 5%;
	width: 95%;
}

.js-menu_activated .hamburger:before{
  width: 100vh;
  height: 100vh;
  transform: translate3d(-50vh, -50vh, 0) scale(5);
}

.js-menu_activated .menu__list{
  display: block;
}

.js-menu_activated .hamburger__button:before{
  transform: translate3d(0, -50%, 0) rotate(45deg);
  top: 50%;
}

.js-menu_activated .hamburger__button:after{
  transform: translate3d(0, -50%, 0) rotate(135deg);
  top: 50%;
}

.js-menu_activated .hamburger__label{
  transform: rotate(-45deg) translate3d(-5.71429px,-6px,0);
  opacity: 0;
}

/*
=====
LEVEL 3. MOBILE ANIMATION STYLES
=====
*/

.menu{
  transition: opacity .2s ease-out;
}

.js-menu_activated .menu{
  will-change: opacity;
  transition-duration: .2s;
  transition-delay: .3s;
}

.hamburger:before{
  will-change: width, height;
  transition: transform .3s cubic-bezier(0.04, -0.1, 0.29, 0.98),
    width .3s cubic-bezier(0.04, -0.1, 0.29, 0.98),
    height .3s cubic-bezier(0.04, -0.1, 0.29, 0.98);
}

.js-menu_activated .hamburger:before{
  transition-duration: 1s;
}

.hamburger__button:before, .hamburger__button:after{
  transition-property: transform;
}

.hamburger__button:before, .hamburger__button:after, .hamburger__label{
  transition-timing-function: ease;
  transition-duration: .15s;
}

.hamburger__label{
  transition-property: transform, opacity;
}

/*
* demo page
*/

@media (min-width: 768px){

  html{
    font-size: 62.5%;
  }
}

@media (max-width: 767px){

  html{
    font-size: 50%;
  }
}

body{
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Open Sans, Ubuntu, Fira Sans, Helvetica Neue, sans-serif;
  font-size: 1.6rem;
  color: var(--colorBlack);

  margin: 0;
  -webkit-overflow-scrolling: touch;   
}

:root{
  --colorBlack: #222;
  --colorWhite: #fff;
  --colorGray: #f0f0f0;
  --colorMain: #ea967c;
  --colorMainLight: #8491d8;
  --colorMainDark: #233286;
}

.page{
  min-height: 100vh;
  display: flex;
}

.page__demo{
  display: flex;
  flex-grow: 1;
}

.page__container{
  max-width: 370px;
  padding: 10px;
  margin: auto;  
  text-align: center;
}

.page__name{
  display: block;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.page__hint{
  display: block;
  line-height: 1.45;
  margin-bottom: .5rem;
}
.menu__list:after {
  content: '';
  display: table;
  clear: both;
}

/* Core Styles */


.navigation-bar {
  height: 50px;
  position: relative;
  z-index: 1000;
}

.navigation-bar .bar {
  background-color: #252525;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}

.navigation-bar .navbox {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
  -webkit-transform: translateY(-200px);
  -ms-transform: translateY(-200px);
  transform: translateY(-200px);
  -webkit-transition: all .2s;
  transition: all .2s;
}

.navigation-bar .menu__list {
  -webkit-transform: translateY(-200px);
  -ms-transform: translateY(-200px);
  transform: translateY(-200px);
}

.navigation-bar.navbox-open .navbox-trigger { background-color: #F44336; }

.navigation-bar.navbox-open .navbox {
  visibility: visible;
  opacity: 1;
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: opacity .3s, -webkit-transform .3s;
  transition: opacity .3s, transform .3s;
}

.navigation-bar.navbox-open .menu__list {
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}

.navbox-trigger .fa {
  font-size: 20px;
  color: #fff;
}

.navbox-trigger:hover { background-color: #484747; }

.navbox {
  background-color: #484747;
  width: 100%;
  max-width: 380px;
  -webkit-backface-visibility: initial;
  backface-visibility: initial;
}

.menu__link {
  width: 100%;
  padding: 25px;
}

.menu__link {
  display: block;
  background-color: #3498db;
  width: 100%;
  height: 100%;
  padding-bottom: 29%;
  float: left;
  border: 2px solid transparent;
  color: #fff;
  position: relative;
}

.menu__link .icon {
  width: 100%;
  height: 50%;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
}

.menu__link .icon i {
  font-size: 35px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-backface-visibility: initial;
  backface-visibility: initial;
}

.menu__link .title {
  padding: 5px;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  width:100%;
  text-align:center;
}

.menu__link:hover {
  border-color: #fff;
  text-decoration: none;
}
.menu__link:not(:nth-child(3n+3)) {
 margin-right: 4.54545454545455%;
}
.header-hamburger .button{background-color: transparent;}

.menu__link:nth-child(n+4) { margin-top: 15px; }
 @media screen and (max-width: 370px) {

	.menu__link .icon i { font-size: 25px; }

	.menu__link .title {
	  padding: 3px;
	  font-size: 11px;
	}
}
</style>
